<template>
  <v-container grid-list-lg>
    <h3>Plates</h3>
    <!---------------------------------------Used----------------------------------------->
    <v-row class="mt-2">
      <v-col xs="6" md="6" lg="6">
        <v-text-field
          v-model="institution.plates.used"
          color="red-darken-3"
          disabled
          label="Used"
          variant="outlined"
        />
      </v-col>
    </v-row>
    <!---------------------------------------Remaining----------------------------------------->
    <v-row row>
      <v-col xs="6" md="6" lg="6">
        <v-text-field
          v-model="institution.plates.remaining"
          color="red-darken-3"
          disabled
          label="Remaining"
          variant="outlined"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  name: "Plates",
  props: ["institution"], // eslint-disable-line vue/require-prop-types
  data() {
    return {
      institutions: [],
    };
  },
  computed: {
    plates() {
      return this.$props.institution.preferences.plates || {};
    },
  },
  methods: {
    getInstitutions() {
      this.loading = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },
  },
};
</script>
